"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SequentialVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class SequentialVfxStepArgs {
    constructor(children) {
        this.children = children;
        this.__typeName = "Sequential";
        this.id = (0, uuid_1.v4)();
    }
}
exports.SequentialVfxStepArgs = SequentialVfxStepArgs;
